import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pad",
  "use": "icon-pad-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pad\"><path fill=\"#ffffff\" d=\"M0 224v576c0 35.3 28.7 64 64 64h896c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64z m512-48c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z m432 624H80c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h864c8.8 0 16 7.2 16 16v544c0 8.8-7.2 16-16 16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol